module.exports = __webpack_public_path__ + "img/2.292edb2c.jpg";